import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import FormItem from '~/components/Form/FormItem';

import { NamePath } from '~/utils/buildNamePath';
import { Form } from '..';
import LtrInput from './LtrInput';

interface Props {
  name: NamePath;
  label?: string;
  disabled?: boolean;
  [itemProps: string]: any;
}

const EmailFormItem: FC<Props> = (props) => {
  const { name, label, disabled, ...itemProps } = props;
  const { t } = useTranslation();

  return (
    <ClearStylesFormItem shouldUpdate>
      {
        // eslint-disable-next-line
        // @ts-ignore
        (form) => {
          const hasError = (form.getFieldError(name) || []).length > 0;
          return (
            <Form.Item
              name={name}
              help={hasError ? undefined : t('For example abc@example.com')}
              disabled={disabled}
              {...itemProps}
            >
              <LtrInput />
            </Form.Item>
          );
        }
      }
    </ClearStylesFormItem>
  );
};

const ClearStylesFormItem = styled(FormItem)`
  &.ant-form-item {
    margin-bottom: 0px !important;
  }
  .ant-form-item-control-input {
    min-height: 0px !important;
  }
`;

export default EmailFormItem;
